import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import AdminLayout from "layouts/Admin/Admin.jsx";
import SuperAdminLayout from "layouts/SuperAdmin/SuperAdminLayout.jsx";
import Login from "layouts/Login/Login.jsx";

import "assets/scss/black-dashboard-react.scss";
import "assets/css/nucleo-icons.css";
import "assets/css/super-admin-modals.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import ThemeContextWrapper, { applyThemeToBody, readStoredTheme } from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import { ApiProvider } from "./contexts/ApiContext";
import { NotificationProvider } from './contexts/NotificationContext';
import GlobalLoading from './components/GlobalLoading/GlobalLoading';

applyThemeToBody(readStoredTheme());

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeContextWrapper>
    <BackgroundColorWrapper>
      <ApiProvider>
        <NotificationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/account/:accountId/*" element={<AdminLayout />} />
            <Route path="/superadmin/*" element={<SuperAdminLayout />} />
            <Route path="/login/*" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        <GlobalLoading />
        </NotificationProvider>
      </ApiProvider>
    </BackgroundColorWrapper>
  </ThemeContextWrapper>
);
